import { useEffect } from 'react';
import { sounds } from '../lib/sounds';
import { useAppStore } from '../stores/app';
import { Leaderboard } from '../components/player/Leaderboard';
import { useGameEvents } from '../hooks/useGameEvents';

export function FinishedPage() {
  const leaderboard = useAppStore((s) => s.leaderboard);
  const gameStats = useAppStore((s) => s.gameStats);
  const userId = useAppStore((s) => s.userId);
  const { leaveRoom, resetRoom } = useGameEvents();

  // Звук победы при загрузке
  useEffect(() => {
    sounds.playVictory();
  }, []);

  const myEntry = leaderboard.find(e => e.playerId === userId);
  const myRank = myEntry?.rank || 0;
  const myScore = myEntry?.score || 0;
  const myCorrect = myEntry?.correctAnswers || 0;
  const winner = leaderboard[0];

  const totalQuestions = gameStats?.totalQuestions || 0;
  const accuracy = totalQuestions > 0 ? Math.round((myCorrect / totalQuestions) * 100) : 0;
  const duration = gameStats?.duration || 0;
  const minutes = Math.floor(duration / 60000);
  const seconds = Math.floor((duration % 60000) / 1000);

  const getPositionEmoji = (rank: number) => {
    if (rank === 1) return '🏆';
    if (rank === 2) return '🥈';
    if (rank === 3) return '🥉';
    return '🎮';
  };

  const getPositionText = (rank: number) => {
    if (rank === 1) return 'Победа!';
    if (rank === 2) return 'Второе место!';
    if (rank === 3) return 'Третье место!';
    return `${rank} место`;
  };

  const getAccuracyEmoji = (acc: number) => {
    if (acc >= 90) return '🌟';
    if (acc >= 70) return '👍';
    if (acc >= 50) return '😊';
    return '💪';
  };

  const handlePlayAgain = () => {
    resetRoom();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 text-white p-6">
      <button onClick={leaveRoom} className="px-3 py-1.5 bg-white/10 hover:bg-white/20 rounded-lg text-sm text-white transition-all mb-2">← Выйти</button>
      {/* Header */}
      <header className="text-center mb-6">
        <div className="text-5xl mb-2">{getPositionEmoji(myRank)}</div>
        <h1 className="text-3xl font-bold mb-1">Игра окончена!</h1>
        {myRank > 0 && (
          <p className="text-xl text-primary-400 font-semibold">{getPositionText(myRank)}</p>
        )}
      </header>

      {/* My Stats Card */}
      {myEntry && (
        <div className="mb-6 p-4 bg-white/10 rounded-2xl">
          <h3 className="text-lg font-semibold mb-3 text-center">Твой результат</h3>
          <div className="grid grid-cols-3 gap-3 text-center">
            <div className="bg-white/5 rounded-xl p-3">
              <div className="text-2xl font-bold text-primary-400">{myScore}</div>
              <div className="text-xs text-gray-400">очков</div>
            </div>
            <div className="bg-white/5 rounded-xl p-3">
              <div className="text-2xl font-bold text-green-400">{myCorrect}/{totalQuestions}</div>
              <div className="text-xs text-gray-400">правильно</div>
            </div>
            <div className="bg-white/5 rounded-xl p-3">
              <div className="text-2xl font-bold text-yellow-400">{accuracy}% {getAccuracyEmoji(accuracy)}</div>
              <div className="text-xs text-gray-400">точность</div>
            </div>
          </div>
        </div>
      )}

      {/* Winner spotlight */}
      {winner && myRank !== 1 && (
        <div className="mb-6 p-4 bg-gradient-to-r from-yellow-500/20 to-orange-500/20 rounded-2xl border border-yellow-500/30 text-center">
          <div className="text-3xl mb-1">👑</div>
          <div className="text-xl font-bold">{winner.displayName}</div>
          <div className="text-yellow-400 font-semibold">{winner.score} очков • {winner.correctAnswers}/{totalQuestions} правильно</div>
        </div>
      )}

      {/* Game Stats */}
      {gameStats && (
        <div className="mb-6 flex justify-center gap-4 text-sm text-gray-400">
          <span>⏱️ {minutes}:{seconds.toString().padStart(2, '0')}</span>
          <span>❓ {totalQuestions} вопросов</span>
          <span>👥 {gameStats.totalPlayers} игроков</span>
        </div>
      )}

      {/* Full Leaderboard */}
      <div className="mb-6">
        
        <Leaderboard />
      </div>

      {/* Actions */}
      <div className="space-y-3">
        <button
          onClick={handlePlayAgain}
          className="w-full py-4 px-6 bg-primary-500 text-white font-bold text-lg rounded-xl
                     hover:bg-primary-600 transition-all"
        >
          🔄 Играть ещё раз
        </button>
        <button
          onClick={leaveRoom}
          className="w-full py-3 px-6 bg-white/10 text-gray-300 font-medium rounded-xl
                     hover:bg-white/20 transition-all"
        >
          Выйти
        </button>
      </div>
    </div>
  );
}
